import { useMemo } from 'react';
import { useCellAnnotationStore } from 'store/useCellAnnotationStore';
import type { CellAnnotationCellKey } from './types';
import { type CellAnnotationMatchColor, computeMatchColor } from './utils/matchStatus';

const useCellAnnotationMatch = (
  cellKey: CellAnnotationCellKey,
  hostValue: number | null | undefined
): CellAnnotationMatchColor => {
  const state = useCellAnnotationStore(store => store.states[cellKey]);
  return useMemo(() => computeMatchColor(hostValue, state), [hostValue, state]);
};

export default useCellAnnotationMatch;
